import { Component, OnInit } from '@angular/core';
import { UsersService } from '@core/services/users.service';

@Component({
  selector: 'app-configs',
  templateUrl: './configs.component.html',
  styleUrls: ['./configs.component.scss']
})
export class ConfigsComponent implements OnInit {

  constructor(private users: UsersService) { }

  public get isAdmin(): boolean {
    return this.users.current && this.users.current.Roles.containsAny("Owner", "Admin");
  }

  public get isOwner(): boolean {
    return this.users.current && this.users.current.Roles.containsAny("Owner");
  }

  ngOnInit(): void {
  }

}
